import { render, staticRenderFns } from "./BackdropTrailer.vue?vue&type=template&id=1b73cb28&scoped=true"
import script from "./BackdropTrailer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackdropTrailer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BackdropTrailer.vue?vue&type=style&index=0&id=1b73cb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73cb28",
  null
  
)

export default component.exports